import type { Resource } from '../../';
export const product_details_backorder: Resource = {"default":"Backorder"};
